import React from 'react';
import {AppShell, ScrollArea, Title, NavLink, Divider} from '@mantine/core';
import { Link, useLocation } from 'react-router-dom';
import {Colors} from "../../../util/colors";

export const Navigation = () => {
    // Get current path from React Router
    const location = useLocation();

    return (
        <AppShell.Navbar >
            <AppShell.Section>
                <Title order={2} m={"sm"}>Navigation</Title>
            </AppShell.Section>
            <Divider></Divider>
            <AppShell.Section grow component={ScrollArea}>
                {/* Example NavLink for Organizations */}
                <NavLink
                    c={Colors.Telegrau4}
                    color={Colors.Telegrau4}
                    label="Übersicht"
                    component={Link}
                    to="/overview"
                    // Highlight as active if the pathname starts with "/organizations"
                    active={location.pathname.startsWith('/overview')}
                />
                <NavLink
                    c={Colors.Telegrau4}
                    color={Colors.Telegrau4}
                    label="Betriebe"
                    component={Link}
                    to="/organizations"
                    // Highlight as active if the pathname starts with "/organizations"
                    active={location.pathname.startsWith('/organizations')}
                />
                {/* Add other NavLinks here if desired */}
                <NavLink
                    c={Colors.Telegrau4}
                    color={Colors.Telegrau4}
                    label="Vorlagen"
                    component={Link}
                    to="/templates"
                    // Highlight as active if the pathname starts with "/organizations"
                    active={location.pathname.startsWith('/templates')}
                />

            </AppShell.Section>

            <AppShell.Section>
                <NavLink
                    c={Colors.Telegrau4}
                    color={Colors.Telegrau4}
                    label="Datenschutzerklärung"
                    component={Link}
                    to="/datenschutzerklärung"
                    // Highlight as active if the pathname starts with "/organizations"
                    active={location.pathname.startsWith('/datenschutzerklärung')}
                />
                <NavLink
                    c={Colors.Telegrau4}
                    color={Colors.Telegrau4}
                    label="Allgemeine Geschäftsbedingungen"
                    component={Link}
                    to="/agb"
                    // Highlight as active if the pathname starts with "/organizations"
                    active={location.pathname.startsWith('/agb')}
                />
                <NavLink
                    c={Colors.Telegrau4}
                    color={Colors.Telegrau4}
                    label="Impressum"
                    component={Link}
                    to="/impressum"
                    // Highlight as active if the pathname starts with "/organizations"
                    active={location.pathname.startsWith('/impressum')}
                />
            </AppShell.Section>
        </AppShell.Navbar>
    );
};
